import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { FiltroRecapitoAnagrafeVO } from "@app/shared/vo/gescor/filtro-recapito-anagrafeVO";
import { TipoRecapitoAnagrafeEnum } from "@app/shared/enum/tipo-recapito-anagrafe-enum";
import { ComuneDTO } from "@app/shared/dto/anagrafe/comuneDTO";
import { CartaceoDTO } from "@app/shared/dto/anagrafe/cartaceoDTO";
import { RicercaRecapitoDTO } from "@app/shared/dto/anagrafe/ricerca-recapitoDTO";
import { ApaciDTO } from "@app/shared/dto/anagrafe/apaciDTO";
import { PecDTO } from "@app/shared/dto/anagrafe/pecDTO";
import { MailDTO } from "@app/shared/dto/anagrafe/mailDTO";
import { PortaleWebDTO } from "@app/shared/dto/anagrafe/portale-webDTO";

@Injectable({
  providedIn: "root"
})
export class MapperRicercaRecapito
  implements MapperInterface<RicercaRecapitoDTO, FiltroRecapitoAnagrafeVO> {
  convertVoToDto(e: FiltroRecapitoAnagrafeVO): RicercaRecapitoDTO {
    const ricercaRecapitoDTO = new RicercaRecapitoDTO();

    ricercaRecapitoDTO.descrizione = e.descrizione;
    ricercaRecapitoDTO.idSoggetto = e.idSoggetto;
    ricercaRecapitoDTO.idRecapito = e.idRecapito;
    if (e.tipoRecapito === TipoRecapitoAnagrafeEnum.APACI.toString()) {
      ricercaRecapitoDTO.apaci = new ApaciDTO();
      ricercaRecapitoDTO.apaci.descrizione = e.descrizione;
      ricercaRecapitoDTO.apaci.idAde = e.indirizzoTelematico;
    }

    if (e.tipoRecapito === TipoRecapitoAnagrafeEnum.PEC.toString()) {
      ricercaRecapitoDTO.pec = new PecDTO();
      ricercaRecapitoDTO.pec.pec = e.indirizzoTelematico;
    }
    if (e.tipoRecapito === TipoRecapitoAnagrafeEnum.MAIL.toString()) {
      ricercaRecapitoDTO.mail = new MailDTO();
      ricercaRecapitoDTO.mail.mail = e.indirizzoTelematico;
    }
    if (e.tipoRecapito === TipoRecapitoAnagrafeEnum.PORTALE_WEB.toString()) {
      ricercaRecapitoDTO.portaleWeb = new PortaleWebDTO();
      ricercaRecapitoDTO.portaleWeb.url = e.indirizzoTelematico;
    }
    if (e.tipoRecapito === TipoRecapitoAnagrafeEnum.CARTACEO.toString()) {
      ricercaRecapitoDTO.cartaceo = new CartaceoDTO();
      ricercaRecapitoDTO.cartaceo.dug = e.dug;
      ricercaRecapitoDTO.cartaceo.indirizzo = e.indirizzo;
      ricercaRecapitoDTO.cartaceo.numeroCivico = e.numeroCivico;
      if (e.comune) {
        ricercaRecapitoDTO.cartaceo.comune = new ComuneDTO();
        ricercaRecapitoDTO.cartaceo.comune.nome = e.comune;
      }
    }
    return ricercaRecapitoDTO || new RicercaRecapitoDTO();
  }
  convertDtoToVo(t: RicercaRecapitoDTO): FiltroRecapitoAnagrafeVO {
    throw new Error("Method not implemented.");
  }
  convertListVoToDto(e: FiltroRecapitoAnagrafeVO[]): RicercaRecapitoDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(t: RicercaRecapitoDTO[]): FiltroRecapitoAnagrafeVO[] {
    throw new Error("Method not implemented.");
  }
}
